module.exports = __webpack_public_path__ + "static/img/book-4.76c896f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/book-4.png
// module id = c97j
// module chunks = 10